export const str2Int = function(str) {
  return parseInt(str);
};

export const strArr2IntArr = function(strArr) {
  let intArr = [];
  strArr.forEach(element => {
    intArr.push(str2Int(element));
  });
  return intArr;
};

export const createArrayOptions = function(options) {
  let optionList = [];
  let labelMapper = {};
  options.forEach((option) => {
    let existOption = labelMapper[option.label];
    if (!existOption) {
      option.innerValue = [option.value];
      optionList.push(option);
      labelMapper[option.label] = option;
      return;
    }
    existOption.innerValue.push(option.value);
  });
  return optionList;
};

export const createAllStatus = function(data) {
  let stauts = [];
  for (let i in data) {
    stauts.push(data[i]);
  }
  return stauts;
};

export const CompareFunc = function(p) { // 比较函数
  return function(m, n) {
    var a = m[p];
    var b = n[p];
    return a - b; // 升序
  };
};



// WEBPACK FOOTER //
// ./src/common/utils.js